import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo11 } from "../../../routes/Module11";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import Modulo11Act1 from "../../../DnD/modulo11Act1";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo11/Actividad 1.mp3";

const Actividad1 = () => {
  const infoUnidad = modulo11.content[0];
  const infoAct = modulo11.content[0].activities[0];
  const crumbs = [
    {
      title: modulo11.title,
      url: "/" + modulo11.url,
    },
    {
      title:
        modulo11.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo11.content[0].activities[1].name}`,
    linkNext: `${modulo11.url}/${modulo11.content[0].path}/${modulo11.content[0].activities[1].path}`,
    titlePrev: modulo11.title,
    linkPrev: modulo11.url,
  };
  const metadata = {
    color: modulo11.color,
    title: `${modulo11.title} - ${infoAct.name}`,
    name: modulo11.title,
  };

  const items = [
    <div className="selectable btn btn-blue shadow mx-3 my-1">
      Poder Legislativo
    </div>,
    <div className="selectable btn btn-blue shadow mx-3 my-1">
      Poder Ejecutivo
    </div>,
    <div className="selectable btn btn-blue shadow mx-3 my-1">
      Poder Judicial
    </div>,
  ];

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <div className="row">
        <div className="col-md-8 col-12">
          <p>
            <small className={`c-${modulo11.color} hat-text`}>
              <FontAwesomeIcon icon={faEye} /> Observamos
            </small>
          </p>
          <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
          <ul>
            <li>Observa las siguientes imágenes.</li>
            <li>
              ¿Quiénes son? Coloca en el espacio en blanco el poder del Estado
              al que representan: Poder Ejecutivo, Poder Legislativo o Poder
              Judicial.
            </li>
          </ul>
        </div>
      </div>
      <Modulo11Act1 items={items} />

      <GuiaDocente>
        <p>
          Observen las imágenes. Pregunte quiénes son las personas que aparecen
          (Presidenta, congresista, jueza). Ayude a resolver la actividad.
          Resalte que las autoridades de un poder no pueden interferir en el
          otro. Los poderes del Estado son independientes.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad1;
